exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-21194b19]{background-color:transparent;color:#ff0061}.modal-header h3[data-v-21194b19]{padding-left:27px}.panel-body a[data-v-21194b19]{text-decoration:underline;color:gray}.panel-body p[data-v-21194b19]{font-size:15px}.panel-body h3[data-v-21194b19]{font-size:20px;margin-bottom:18px}.panel-body[data-v-21194b19]{padding-bottom:0;padding-top:5px}strong[data-v-21194b19]{color:#0f7ec2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21194b19","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ModalTraining.vue
// module id = V70f
// module chunks = 32 101